import { ArrowRight } from "lucide-react";
import { PRICING } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { useSectionNav } from "@/hooks/useSectionNav";

const Pricing = () => {
  const go = useSectionNav();
  return (
    <section id="pricing" className="border-y border-white/10 bg-surface" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
        <SectionHeading
          index="02"
          eyebrow="Pricing"
          title="Simple, Upfront Pricing"
          sub="Interior + exterior mobile detailing. No surprises — you'll always know the price before work begins."
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {PRICING.map((tier, i) => (
            <Reveal key={tier.name} delay={i * 0.08} y={32}>
              <article
                className="group flex h-full flex-col border border-white/10 bg-panel p-7 transition-colors duration-300 hover:border-blue-500/50"
                data-testid={`pricing-card-${i}`}
              >
                <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
                  Starting at
                </p>
                <p className="mt-3 font-display text-6xl font-bold leading-none tracking-tight text-white transition-colors duration-300 group-hover:text-blue-400">
                  {tier.price}
                </p>
                <h3 className="mt-5 border-t border-white/10 pt-5 font-display text-xl font-bold uppercase tracking-wide text-white">
                  {tier.name}
                </h3>
                <ul className="mt-3 space-y-1.5">
                  {tier.examples.map((ex) => (
                    <li key={ex} className="text-sm text-slate-400">
                      {ex}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col items-start justify-between gap-6 border border-white/10 bg-obsidian p-6 sm:flex-row sm:items-center sm:p-7">
            <p className="max-w-2xl text-sm leading-relaxed text-slate-400" data-testid="pricing-disclaimer">
              Final pricing may vary depending on vehicle size, condition, excessive dirt, stains, pet hair, or the
              amount of time required. These are starting prices — any difference is always discussed before work
              begins, never after.
            </p>
            <button onClick={() => go("quote")} className="btn-primary shrink-0" data-testid="pricing-quote-button">
              Get Your Quote
              <ArrowRight size={17} strokeWidth={2.4} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Pricing;
